import { Observable } from "rxjs";

/**
 * Interface that represents the terms and conditions repository.
 */
export abstract class UrlRepo {
  abstract getTermsAndConditions(): Observable<string>;
  abstract getPrivacyPolicy(): Observable<string>;
}
